import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label, InputGroup, InputGroupAddon, Button, Alert } from 'reactstrap';
import { startSetProfile } from '../../actions/webmaster';
import BlockAlert from '@components/BlockAlert/BlockAlert';
import { slaves } from '../../services/ApiService';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';
import WithPlaceholder from '../../hoc/WithPlaceholder';

class ConnectMeToMaster extends Component {
  state = {
    loading: false,
    hash: '',
  };

  handleChange = ({ target }) => {
    this.setState(() => ({ hash: target.value }));
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { startSetProfile, showAlert, intl } = this.props;
    const { hash } = this.state;
    this.setState(() => ({ loading: true }));
    slaves
      .connectAsSlave(hash)
      .then(startSetProfile)
      .then(() => {
        showAlert({
          message: iFMessage({ intl, id: 'slaves.connect-to-master.alert.success' }),
          alertType: 'success',
        });
      })
      .catch(({ response = {} }) => {
        let message = '';
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;
          message = error.message;
        } else {
          message = iFMessage({ intl, id: 'slaves.error' });
        }
        showAlert({
          message,
          alertType: 'danger',
        });
      })
      .finally(() => this.setState(() => ({ loading: false })));
  };

  render() {
    const { hash } = this.state;
    const {
      master: { slave, master },
    } = this.props;

    return (
      <Fragment>
        <div className="annotation">
          <p>
            <FMessage id="slaves.connect-to-master.p-1" />
          </p>
          <p>
            <FMessage id="slaves.connect-to-master.p-2" />
          </p>
        </div>
        {!slave && !master && (
          <FormGroup className="form-group-upper-label">
            <Label>
              <FMessage id="slaves.add-member.link.title" />
            </Label>
            <InputGroup>
              <WithPlaceholder
                name="url"
                value={hash}
                onChange={this.handleChange}
                placeholder="slaves.connect-to-master.placeholder"
                autoComplete="off"
              />
              <InputGroupAddon addonType="append">
                <Button type="button" color="primary" onClick={this.onSubmit} disabled={!hash}>
                  <FMessage id="slaves.connect-to-master.btn.label" />
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        )}

        {!slave && master && (
          <BlockAlert type="warning" title={<FMessage id="slaves.connect-to-master.blocked" />} />
        )}

        {slave && (
          <BlockAlert
            type="success"
            title={
              <span>
                <FMessage id="slaves.connect-to-master.connected" />{' '}
                <b className="master-account-info-block">{slave.login}</b>
              </span>
            }
          />
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startSetProfile: () => dispatch(startSetProfile()),
});

export default connect(null, mapDispatchToProps)(ConnectMeToMaster);
